import { ref } from 'vue'

const paramsConfirm = ref({
  content: '',
  options: {},
  props: {},
})

// MFC2-1626 — la visibilite est une donnee a part entiere, et non un champ `modelValue` cache
// dans les props. Avant, la modale etait pilotee par `props.modelValue` recopie a la main, ce qui
// obligeait le composant a synchroniser deux etats par des watchers croises.
const visible = ref(false)

const msgBoxConfirm = (content, props = {}, options = {}) => {
  // Les props de l'appel precedent ne sont PLUS reportees. Elles l'etaient (`...paramsConfirm.value.props`),
  // ce qui faisait survivre un `onOk` d'une modale a la suivante : un « Are you sure ? » ouvert apres
  // une suppression annulee pouvait rejouer le onOk de la suppression precedente.
  paramsConfirm.value = { content, options, props: { ...props } }
  visible.value = true
}

// Fermeture sans vider le contenu : la modale garde son titre et ses boutons pendant la transition.
const hide = () => {
  visible.value = false
}

// MFC2-1626 — le vidage est DIFFERE a la fin de la transition (@hidden).
// Quand il avait lieu des le debut de la fermeture, les props retombaient sur les valeurs par defaut
// et l'utilisateur voyait la modale se transformer sous ses yeux : le titre redevenait
// « Are you sure ? » et un bouton Cancel apparaissait sur une modale ouverte en okOnly.
// Retour Diana du 27/08 : « j'ai des pop up "Are you sure" dans tous les sens ».
const reset = () => {
  visible.value = false
  paramsConfirm.value = {
    content: '',
    options: {},
    props: {},
  }
}

export default {
  paramsConfirm,
  visible,
  msgBoxConfirm,
  hide,
  reset,
}
